import React, { useEffect, useState } from "react";
import { getGroupPurchases } from "../../utilities/api";
import GroupPurchaseTable from "./Table";

export default function GroupPurchasesWrapper({ organization }) {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [count, setCount] = useState(0);

  const loadPurchases = () => {
    getGroupPurchases(organization.uuid, page, pageSize)
      .then((res) => {
        setCount(Number(res.data?.count));
        setData(res.data.groupPurchases);
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    if (organization) loadPurchases();
  }, [page]);

  return (
    <>
      <GroupPurchaseTable
        data={data}
        page={page}
        setPage={setPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        count={count}
      />
    </>
  );
}
